import React from "react";
import { Container } from "react-bootstrap";
import "./Terms_Conditions.css";

const Terms_Conditions = () => {
  return (
    <>
      <section className="Privacy_Policy Terms_Conditions">
        <div className="privacy-section">
          <div className="container">
            <div className="privacy-header">
              <div className="privacy-header-left">
                <h2 className="privacy-title">TERMS & CONDITIONS</h2>
              </div>
              <div className="privacy-header-line"></div>
            </div>

            <h4 className="privacy-subtitle">TERMS AND CONDITIONS FOR USERS</h4>

            <p className="privacy-description">
              This document is an electronic record in terms of the Information
              Technology Act, 2000 and rules thereunder as applicable & the
              provisions pertaining to electronic records in various statutes as
              amended by the Information Technology Act, 2000
            </p>
          </div>
        </div>

        <Container>
          <div className="privacy_item">
            <p className="privacy_description"></p>
          </div>

          <div className="privacy_item">
            <h5 className="privacy_head">1.Acceptance and Scope</h5>

            <p className="privacy_description">
              Lorem ipsum is simply dummy text of the printing and typesetting
              industry. Lorem ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type & scrambled it to make a type specimen book. It has survived
              not only five centuries, but also the leap into electronic
              typesetting, remaining essentially unchanged. It was popularised
              in the 1960s with the release of letraset sheets containing lorem
              ipsum passages, and more recently with desktop publishing software
              like Aldus PageMaker including versions of lorem ipsum.
            </p>
          </div>

          <div className="privacy_item">
            <h5 className="terms_description">Agreement to Terms:</h5>
            <p className="privacy_description">
              Explicit statement that by downloading, installing, or using the
              application, the User agrees to be bound by the T&Cs and the
              Privacy Policy.
            </p>
          </div>

          <div className="privacy_item">
            <h5 className="terms_description">Company's Role</h5>
            <p className="privacy_description">
              Defines the Company as a technology platform that connects Users
              with Independent Third-Party Transportation Providers (Drivers).
              The Company does not provide transportation services itself.
            </p>
          </div>

          <div className="privacy_item">
            <h5 className="terms_description">Eligibility:</h5>
            <p className="privacy_description">
              Requires the User to be of legal age (e.g., 18 years old) to enter
              into a binding contract or to use the services under the
              supervision of a parent/guardian.
            </p>
          </div>

          <div className="privacy_item">
            <h5 className="terms_description">Amendments:</h5>
            <p className="privacy_description">
              Reserves the Company's right to modify the T&Cs at any time, with
              continued use constituting acceptance of the updated terms.
            </p>
          </div>

          <div className="privacy_item">
            <h5 className="privacy_head">2. User Account and Conduct</h5>
            <h6 className="terms_description">Account Registration</h6>
            <p className="privacy_description">
              Requirements for accurate and complete registration information
              (name, mobile number, email, payment details).
            </p>

            <h6 className="terms_description">Account Security</h6>
            <p className="privacy_description">
              User's sole responsibility for maintaining the confidentiality of
              their password and for all activities that occur under their
              account.
            </p>

            <h6 className="terms_description">Prohibited Activities</h6>
            <p className="privacy_description">
              Strict guidelines on User conduct, including:
              <br></br>
              <p>
                No use for unlawful or fraudulent purposes.<br></br> No smoking,
                consuming alcohol, or illegal drugs in the vehicle.<br></br> No
                littering, physical abuse, or verbal harassment of the Driver or
                other passengers. <br></br>
                No causing property damage to the vehicle.
              </p>
            </p>

            <h5 className="privacy_head">
              3.Pricing, Payments, and Cancellations
            </h5>
            <h6 className="terms_description">Fare Calculation</h6>
            <p className="privacy_description">
              Details how fares are calculated (base fare, distance, time, surge
              pricing/Prime Time, tolls, taxes).
            </p>

            <h6 className="terms_description">Payment Method</h6>
            <p className="privacy_description">
              Details how fares are calculated (base fare, distance, time, surge
              pricing/Prime Time, tolls, taxes).
            </p>

            <h6 className="terms_description">Fare Estimates</h6>
            <p className="privacy_description">
              Notes that a quoted fare is an estimate and the final charge may
              vary based on the actual route, time, and traffic.
            </p>

            <h6 className="terms_description">Cancellation Policy</h6>
            <p className="privacy_description">
              Details how fares are calculated (base fare, distance, time, surge
              pricing/Prime Time, tolls, taxes).
            </p>

            <h6 className="terms_description">Damage/Cleaning Fee</h6>
            <p className="privacy_description">
              User agrees to pay a fee if the Driver reports the User has
              materially damaged or excessively dirtied the vehicle (subject to
              Company discretion and verification).
            </p>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Terms_Conditions;
